// Version is a string!
enum Version {
  V1 = "1",
  V2 = "2",
  V2_BETA = "2 (beta)",
}

export default Version;
